import React, { useState, useContext, useEffect } from 'react';
import axios from 'axios';
import UserContext from '../../contexts/UserContext';
import { useNavigate } from 'react-router-dom';
import authenticate from '../../utils/Authenticate';

const CreateMiqaatModule = () => {
  const { user, setUser } = useContext(UserContext);
  const navigate = useNavigate();
  const [selectedMenu, setSelectedMenu] = useState('');
  const [loading, setLoading] = useState(true);
  const [menus, setMenus] = useState([]);

  const [miqaat, setMiqaat] = useState({
    name: '',
    thaal: 0,
    mumineenCount: 0,
  });

  const [notification, setNotification] = useState({ message: '', type: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setMiqaat({
      ...miqaat,
      [name]: value,
    });
  };

  const handleMenuChange = async (e) => {
      const menuId = e.target.value;
      setSelectedMenu(menuId);
    };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!miqaat.name) {
      setNotification({ message: 'Miqaat name is required', type: 'error' });
      return;
    }

    const thaalCount = parseInt(miqaat.thaal);
    const mumineenCount = parseInt(miqaat.mumineenCount);

    if (isNaN(thaalCount) || isNaN(mumineenCount) || thaalCount < 0 || mumineenCount < 0) {
      setNotification({ message: 'Thaal Count and Mumineen Count must be non-negative numbers', type: 'error' });
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URI}/api/miqaat/create`,
        {
          miqaat: {
            name: miqaat.name,
            thaal: thaalCount,
            mumineenCount: mumineenCount,
            menu: selectedMenu
          },
        },
        { withCredentials: true }
      );
      setNotification({ message: 'Miqaat Created', type: 'success' });
      setMiqaat({ name: '', thaal: 0, mumineenCount: 0 });
    } catch (error) {
      if (error.response && error.response.status === 409) {
        setNotification({ message: 'Duplicate entry. Miqaat already exists.', type: 'error' });
        console.log(error);
      } else {
        setNotification({ message: 'An error occurred while creating the Miqaat.', type: 'error' });
      }
    }
  };

  useEffect(() => {
    console.log(user);
    const fetchMenus = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${process.env.REACT_APP_API_URI}/api/menu/getAll`, { withCredentials: true });
        console.log(response.data);
        setMenus(response.data.data);
      } catch (error) {
        console.error('Error fetching menus:', error);
        // setNotification({ message: 'Error fetching menus', type: 'error' });
      } finally {
        setLoading(false);
      }
    };

    fetchMenus();
  }, []);

  useEffect(() => {
    async function startup() {
      if (!user) {
        await authenticate(setUser, navigate);
      }
    }
    startup();
  }, [user, navigate, setUser]);

  return (
    <>
      <div className="wrapper">
        <div className="w-full">
          <h2 className="text-base font-bold bg-lime-800 text-white p-3 py-4 text-center">Create Miqaat</h2>
          {notification.message && (
            <div className={`p-2 mb-4 ${notification.type === 'error' ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'}`}>
              {notification.message}
            </div>
          )}
        </div>
        <div className="max-w-md mx-auto">
          <form onSubmit={handleSubmit} className="px-8 pt-6 pb-8 mb-4">
            <div className="mb-4">
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="name">
                Miqaat Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={miqaat.name}
                onChange={handleChange}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                required
              />
            </div>
            {/* Menu Selection */}
            <div className="mb-6">
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="menu-select">
                Select Menu
              </label>
              <select 
                id="menu-select"
                value={selectedMenu} 
                onChange={handleMenuChange}
                disabled={loading}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                required
              >
                <option value="">
                  {loading ? 'Loading menus...' : 'Choose a menu'}
                </option>
                {menus.map((menu) => (
                  <option key={menu._id} value={menu._id}>
                    {menu.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="thaal">
                Thaal Count
              </label>
              <input
                type="number"
                id="thaal"
                name="thaal"
                value={miqaat.thaal}
                onChange={handleChange}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                required
                min="0"
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="mumineenCount">
                Mumineen Count
              </label>
              <input
                type="number"
                id="mumineenCount"
                name="mumineenCount"
                value={miqaat.mumineenCount}
                onChange={handleChange}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                required
                min="0"
              />
            </div>
            <div className="flex items-center justify-between">
              <button
                type="submit"
                className="bg-fmb text-white font-bold py-2 px-4 rounded-full focus:outline-none focus:shadow-outline"
              >
                Create Miqaat
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default CreateMiqaatModule;
